export default  {
  bindings: {
    value: '=',
    placeholder: '@'
  },
  controller: 'treatmentsSelectController',
  template: require('../views/treatments.select.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/treatment/components/treatments.select.component.js